import { render, staticRenderFns } from "./Rel_0001.vue?vue&type=template&id=0ec7e117&scoped=true"
import script from "./Rel_0001.vue?vue&type=script&lang=js"
export * from "./Rel_0001.vue?vue&type=script&lang=js"
import style0 from "./Rel_0001.vue?vue&type=style&index=0&id=0ec7e117&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec7e117",
  null
  
)

export default component.exports